module.exports = __webpack_public_path__ + "static/ART_Logo-usage_incorrect2-6b455acc05ac43622748a10d76b95a2f.svg";